export const ADD_QUESTIONNAIRE_MODAL_LABELS = {
  modalTitle: 'Add questionnaire',
  toasts: {
    questionnaireCreated: 'New questionnaire created successfully!',
    createFailed: 'Failed to create new questionnaire',
  },
} as const
